import React from 'react';
import TextField from '../../../Forms/TextField';

const BenefitsHubSettingsForm = () => {
    return (
        <div className="mt-1">
            <p>
                For the Header, you have the option to use Accent field or not. Using just the "Benefits Hub Hero Header" the text
                will all be the same color. If you use all 3 the accent will be in the middle. Omitting the "Benefits Hub Hero Header" or "... End" fields will put the accent at the beginning or end respectively.
            </p>
            <p>For the Benefits Hub Hero Image, enter URL with 'https://cdn.igrad.com/' domain.</p>
            <TextField 
                label="Benefits Hub Hero Header" 
                placeholder="Enter Header text" 
                type="text" 
                name="benefitsHubHeroHeader" 
            />
            <TextField
                label="Benefits Hub Hero Header Accent"
                placeholder="Enter Header text"
                type="text"
                name="benefitsHubHeroHeaderAccent"
            />
            <TextField 
                label="Benefits Hub Hero Header End" 
                placeholder="Enter Header text" 
                type="text" 
                name="benefitsHubHeroHeaderEnd" 
            />
            <hr />
            <TextField 
                label="Benefits Hub Hero Subheader" 
                placeholder="Enter Subheader text" 
                type="text" 
                name="benefitsHubHeroSubHeader" 
            />
            <TextField 
                label="Benefits Hub Hero Image" 
                inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                placeholder="Enter URL with 'https://cdn.igrad.com/' domain" 
                type="text" 
                name="benefitsHubHeroImage" 
            />
            <hr />
            <TextField 
                label="Benefits Hub Featured Subheading" 
                placeholder="Enter Featured section subheading text" 
                type="text" 
                name="benefitsHubFeaturedSubHeading" 
            />
        </div>
    );
};

export default BenefitsHubSettingsForm;
